function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg002User(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.748,
    height: 18.748,
    viewBox: "0 0 18.748 18.748",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    id: "prefix___002-user",
    d: "M17.26 11.9a8.781 8.781 0 0 0-2.24-1.4.732.732 0 0 0-.595 1.338A7.324 7.324 0 0 1 16.294 13a2.92 2.92 0 0 1 .989 2.195v1.355a.733.733 0 0 1-.732.732H2.2a.733.733 0 0 1-.732-.732V15.2a2.92 2.92 0 0 1 .986-2.2c.74-.65 2.9-2.163 6.92-2.163a5.426 5.426 0 1 0-3.3-1.125A10.181 10.181 0 0 0 1.487 11.9 4.385 4.385 0 0 0 0 15.2v1.355a2.2 2.2 0 0 0 2.2 2.2h14.351a2.2 2.2 0 0 0 2.2-2.2V15.2a4.385 4.385 0 0 0-1.491-3.3zM5.419 5.419a3.955 3.955 0 1 1 3.955 3.955 3.959 3.959 0 0 1-3.955-3.955zm0 0",
    "data-name": "002-user",
    style: {
      opacity: 0.4
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg002User);
export default __webpack_public_path__ + "static/media/002-user.41248ba3a29bfe541fb3ded11c9578b4.svg";
export { ForwardRef as ReactComponent };